import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { JobRepairPhotoCreatableInterface } from '../interfaces/job-repair-photo-creatable.interface';
import { JobRepairPhotoDto } from './job-repair-photo.dto';

export class JobRepairPhotoCreateDto
  extends IntersectionType(
    PickType(JobRepairPhotoDto, ['fileName', 'jobRepairId', 'repairPhotoType']),
    PartialType(PickType(JobRepairPhotoDto, ['metaData'])),
  )
  implements JobRepairPhotoCreatableInterface {}
